// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#root {
  height: 100%;
}

.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-grow: 1;
}

.image-container {
  flex: 1 0 20%; /* 5 images per row on larger screens */
  margin: 10px;
  cursor: pointer;
  max-width: calc(20% - 20px); /* Adjust based on flex-basis */
}

.img-fluid {
  width: 100%;
  height: auto;
}

.pagination {
  display: flex;
  justify-content: center;
  padding: 20px;
  list-style: none;
}

.page-item {
  margin: 0 5px;
}

.page-link {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 50px; /* Soft round edges */
  text-decoration: none;
  color: #e6e0e0;
  transition: background-color 0.3s, border-color 0.3s, color 0.3s;
}

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
  border-color: #dee2e6;
}

.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  overflow: hidden;
}

.modal-content {
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.modal-content img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.btn-close-modal {
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
}

/* Adjustments for different screen sizes */
@media (max-width: 1024px) {
  .image-container {
      flex: 1 0 30%; /* 3 images per row on medium screens */
      max-width: calc(30% - 20px); /* Adjust based on flex-basis */
  }
}

@media (max-width: 768px) {
  .image-container {
      flex: 1 0 45%; /* 2 images per row on smaller screens */
      max-width: calc(45% - 20px); /* Adjust based on flex-basis */
  }
}

@media (max-width: 480px) {
  .image-container {
      flex: 1 0 100%; /* 1 image per row on very small screens */
      max-width: calc(100% - 20px); /* Adjust based on flex-basis */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Gallery.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa,EAAE,uCAAuC;EACtD,YAAY;EACZ,eAAe;EACf,2BAA2B,EAAE,+BAA+B;AAC9D;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB,EAAE,qBAAqB;EAC1C,qBAAqB;EACrB,cAAc;EACd,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE;MACI,aAAa,EAAE,uCAAuC;MACtD,2BAA2B,EAAE,+BAA+B;EAChE;AACF;;AAEA;EACE;MACI,aAAa,EAAE,wCAAwC;MACvD,2BAA2B,EAAE,+BAA+B;EAChE;AACF;;AAEA;EACE;MACI,cAAc,EAAE,0CAA0C;MAC1D,4BAA4B,EAAE,+BAA+B;EACjE;AACF","sourcesContent":["html, body {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n#root {\n  height: 100%;\n}\n\n.container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.gallery {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  flex-grow: 1;\n}\n\n.image-container {\n  flex: 1 0 20%; /* 5 images per row on larger screens */\n  margin: 10px;\n  cursor: pointer;\n  max-width: calc(20% - 20px); /* Adjust based on flex-basis */\n}\n\n.img-fluid {\n  width: 100%;\n  height: auto;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  padding: 20px;\n  list-style: none;\n}\n\n.page-item {\n  margin: 0 5px;\n}\n\n.page-link {\n  padding: 10px 15px;\n  border: 1px solid #ddd;\n  border-radius: 50px; /* Soft round edges */\n  text-decoration: none;\n  color: #e6e0e0;\n  transition: background-color 0.3s, border-color 0.3s, color 0.3s;\n}\n\n.page-item.disabled .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n.modal {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.75);\n  overflow: hidden;\n}\n\n.modal-content {\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.modal-content img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.btn-close-modal {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background: none;\n  border: none;\n  color: white;\n  font-size: 1.5rem;\n  cursor: pointer;\n}\n\n/* Adjustments for different screen sizes */\n@media (max-width: 1024px) {\n  .image-container {\n      flex: 1 0 30%; /* 3 images per row on medium screens */\n      max-width: calc(30% - 20px); /* Adjust based on flex-basis */\n  }\n}\n\n@media (max-width: 768px) {\n  .image-container {\n      flex: 1 0 45%; /* 2 images per row on smaller screens */\n      max-width: calc(45% - 20px); /* Adjust based on flex-basis */\n  }\n}\n\n@media (max-width: 480px) {\n  .image-container {\n      flex: 1 0 100%; /* 1 image per row on very small screens */\n      max-width: calc(100% - 20px); /* Adjust based on flex-basis */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
